import { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';

import { NavigateLinks } from '@/components';
import { userHasPermission } from '@/components/security/AppRoles';
import { useUserInfo } from '@/hooks';

import MenuCard from '../../components/MenuCard';
import {
  childrenBusinessPageBreadcrumbs,
  logisticsNetworkMenuItems,
} from '../../config';

const LogisticsNetwork = () => {
  const navigate = useNavigate();
  const { permissions } = useUserInfo();

  const breadcrumbs = useMemo(
    () => childrenBusinessPageBreadcrumbs(navigate),
    [navigate]
  );

  const items = useMemo(
    () =>
      logisticsNetworkMenuItems.filter(
        (item) =>
          !item.permission || userHasPermission(permissions, item.permission)
      ),
    [permissions]
  );

  return (
    <section className='w-full h-full flex flex-col gap-8 p-5'>
      <NavigateLinks actualPage='Red logística' breadcrumbs={breadcrumbs} />

      <ul className='w-full max-w-[1100px] mx-auto grid grid-cols-[repeat(auto-fill,200px)] gap-x-[40px] gap-y-[32px] justify-center content-center flex-1'>
        {items.map((item) => (
          <MenuCard
            key={item.id}
            label={item.label}
            icon={item.icon}
            alt={item.alt}
            onClick={() => navigate(item.route)}
            imageClassName={item.imageClassName}
            cardClassName={item.cardClassName}
            labelClassName={item.labelClassName}
          />
        ))}
      </ul>
    </section>
  );
};

export default LogisticsNetwork;
